/*
 * Days the home header marks. Each rule was checked against the sponsoring society's
 * published dates for several years (see observances.test.js). Order matters: a single-day
 * observance beats a week it falls inside.
 *
 *   Ether Day                          October 16 (first public ether anesthetic, 1846)
 *   Anesthesia Tech Day                March 31 (ASATT)
 *   Thank a Resident Day               last Friday of February (Gold Foundation)
 *   CRNA Week                          week starting the third Sunday of January (AANA)
 *   Physician Anesthesiologists Week   week starting the last Sunday of January (ASA)
 *   CAA Week                           week starting the third Monday of February (AAAA)
 *   Anesthesia Tech Week               Monday-to-Sunday week containing March 31 (ASATT)
 */

const nthWeekday = (year, month, weekday, n) => {
  // month 0-11, weekday 0 (Sun) - 6 (Sat), n 1-based
  const first = new Date(year, month, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return new Date(year, month, 1 + offset + (n - 1) * 7);
};
const lastWeekday = (year, month, weekday) => {
  const last = new Date(year, month + 1, 0);
  const back = (last.getDay() - weekday + 7) % 7;
  return new Date(year, month, last.getDate() - back);
};
const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
const inWeekFrom = (d, start) => { const diff = Math.floor((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - start) / 86400000); return diff >= 0 && diff < 7; };
const mondayOfWeek = (d) => { const back = (d.getDay() + 6) % 7; return new Date(d.getFullYear(), d.getMonth(), d.getDate() - back); };

export const OBSERVANCES = [
  { id: 'ether', label: 'Happy Ether Day', icon: 'flask', test: (d) => d.getMonth() === 9 && d.getDate() === 16 },
  { id: 'tech-day', label: 'Happy Anesthesia Tech Day', icon: 'wrench', test: (d) => d.getMonth() === 2 && d.getDate() === 31 },
  { id: 'residents', label: 'Thank you, residents', icon: 'heart', test: (d) => d.getMonth() === 1 && sameDay(d, lastWeekday(d.getFullYear(), 1, 5)) },
  { id: 'crna', label: 'Happy CRNA Week', icon: 'party', test: (d) => inWeekFrom(d, nthWeekday(d.getFullYear(), 0, 0, 3)) },
  { id: 'paw', label: 'Happy Physician Anesthesiologists Week', icon: 'party', test: (d) => inWeekFrom(d, lastWeekday(d.getFullYear(), 0, 0)) },
  { id: 'caa', label: 'Happy CAA Week', icon: 'party', test: (d) => inWeekFrom(d, nthWeekday(d.getFullYear(), 1, 1, 3)) },
  { id: 'tech-week', label: 'Happy Anesthesia Tech Week', icon: 'wrench', test: (d) => inWeekFrom(d, mondayOfWeek(new Date(d.getFullYear(), 2, 31))) },
];

/** The observance for a date, or null. A `?observance=<id>` on the URL previews one. */
export const observanceFor = (date = new Date(), search = typeof window !== 'undefined' ? window.location.search : '') => {
  const forced = /[?&]observance=([a-z-]+)/.exec(search || '');
  if (forced) return OBSERVANCES.find((o) => o.id === forced[1]) || null;
  if (/[?&]etherday/.test(search || '')) return OBSERVANCES[0];
  return OBSERVANCES.find((o) => o.test(date)) || null;
};
